import { TABLE_COLUMN_WIDTHS } from '@/components/lemmala-design-system/table/consts'

// Measured widths (px)
export const WIDTH_CONTROL = 336
export const WIDTH_CATEGORY = 100
export const WIDTH_THIRD_PARTY_ADHERENCE = 382
export const WIDTH_VALIDATION_STATUS = 200
export const WIDTH_EVIDENCE_REQUEST = 175
export const WIDTH_CATEGORY_FILL = 350
export const WIDTH_SCOPE = 300
export const WIDTH_CONTROL_WEIGHT = TABLE_COLUMN_WIDTHS.sm
export const WIDTH_GAPS = TABLE_COLUMN_WIDTHS.sm
